export const reachStepSX = {
  gridContainer: {
    display: "flex",
    py: 12,
  },
  boxPadding: {
    p: 3,
  },
  questionBoxHeight: {
    height: { lg: "100px", md: "100px" },
    my: 1,
  },
  textFieldMargin: {
    m: "10px",
  },
  yesNoBox: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    pl: { xs: 0, sm: 2 },
    mb: { xs: 1, sm: 0 },
    mt: 2,
  },
  footerTitle: {
    fontWeight: 600,
    display: { xs: "block", md: "none" },
    textAlign: "center",
    color: "initial",
    mt: 2,
  },
};